/**
 * Created by dboukezoula on 23/04/2018.
 */
jQuery(document).ready(function () {
    function CheckSav() {
        var curRegion = $('#region').val();
        var curCountries = $('#countries').val();
        var curCity = $('#city').val();
        var arrCurRegion = curRegion.split("_");
        var arrCurCountries = curCountries.split("_");
        var arrCurCity = curCity.split("_");
        var showElement = [];
        var hideElement = [];
        var hideSelectCountry = [];
        var hideSelectCity = [];

        arrCurRegion.forEach(function(curReg) {
            $("#countries option").each(function()
            {
                var optionCountry = $(this).val();
                console.log('optionCountry');

                var optionVal = "option[value='" + optionCountry + "']";

                $("#countries "+optionVal).hide();
                var optionCountry = optionCountry.split("_");
                optionCountry.forEach(function(optCountry) {


                    if(optCountry!='' && curReg == optCountry){

                        hideSelectCountry.push(optionVal);
                    }
                });
            });
        });

        hideSelectCountry.forEach(function(element) {

            $("#countries "+element).show();
        });




        arrCurCountries.forEach(function(curCoun) {
            $("#city option").each(function()
            {
                var optionCity = $(this).val();


                var optionVal = "option[value='" + optionCity + "']";

                $("#city "+optionVal).hide();
                var optionCity = optionCity.split("_");
                optionCity.forEach(function(optCy) {


                    if(optCy!='' && curCoun == optCy){

                        hideSelectCity.push(optionVal);
                    }
                });
            });
        });

        hideSelectCity.forEach(function(element) {

            $("#city "+element).show();
        });


        if($('#countries').val() == 0 && $('#region').val() != 0){
            arrCurRegion.forEach(function(curReg) {
                $("#city option").each(function()
                {
                    var optionCity = $(this).val();
                    console.log('optionCity');

                    var optionVal = "option[value='" + optionCity + "']";

                    $("#city "+optionVal).hide();
                    var optionCity = optionCity.split("_");
                    optionCity.forEach(function(optCy) {
                        if(optCy!='' && curReg == optCy){
                            hideSelectCity.push(optionVal);
                        }
                    });
                });
            });
            hideSelectCity.forEach(function(element) {
                $("#city "+element).show();
            });
        }

        //var curCategories = parseInt($('#languages').val());
        //Get the current select project and make it an integer
        $('.accordion__filter').each(function () { //Loop through each option
            var arrRegion = $(this).attr('data-region'); //Put the array of projects in a variable
            var arrCountries = $(this).attr('data-countries');
            var arrCity = $(this).attr('data-city');
            arrRegion = arrRegion.split("_");
            arrCountries = arrCountries.split("_");
            arrCity = arrCity.split("_");

            var isRegion = false;
            var isCountry = false;
            var isCity = false;
        //    console.log('Region');
        //    console.log(arrCurRegion);
        //    console.log(arrRegion);
            arrCurRegion.forEach(function(curReg) {
                arrRegion.forEach(function(arrReg) {
                    if(curReg == arrReg)
                    {
                  //      console.log('show Region');
                        isRegion = true;

                    }
                });
            });
       //     console.log('Countries');
       //     console.log(arrCurCountries);
       //     console.log(arrCountries);
            arrCurCountries.forEach(function(curCoun) {
                arrCountries.forEach(function(arrCoun) {
                    if(curCoun == arrCoun)
                    {
                     //   console.log('show isCountry');
                        isCountry = true;

                    }
                });
            });


            if($('#city').val() == $(this).attr('data-city')){
                isCity = true;
            }
            console.log('boolean');
          //  console.log(isRegion);
            console.log($('#city').val());
            console.log($(this).attr('data-city'));
            console.log(isCity);
         //   console.log(isCountry);
            if((isRegion == true || $('#region').val() == 0) && (isCity == true || $('#city').val() == 0) &&
                (isCountry == true || $('#countries').val() == 0)){
                var elmShow = $(this);
                showElement.push(elmShow);
            } else {
                var elmShow = $(this);
                hideElement.push(elmShow);
            }
        });

        showElement.forEach(function(element) {
            element.show();
        });
        hideElement.forEach(function(element) {
            element.hide();
        });
    }

    CheckSav(); //Call the function when we run the page (at bottom of page, or within $(document).ready or something similar)
    $('#region').on('change', function() { //When we change the project, call the function
        CheckSav();
    });
    $('#countries').on('change', function() { //When we change the project, call the function
        CheckSav();
    });

    $('#city').on('change', function() { //When we change the project, call the function
        CheckSav();
    });
});


// WEBPACK FOOTER //
// ../work/src/js/sav.js